import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.pending_view.title',
        defaultMessage: `Thanks! We're reviewing your application`
    },
    description: {
        id: '_.pending_view.description',
        defaultMessage: `We'll aim to email you with a decision within 24 hours- we’re receiving more applications than usual at the moment, so please bear with us if we take a little longer.`
    },
    contact: {
        id: '_.pending_view.contact',
        defaultMessage: `Contact us on {phoneNumber} if your application is urgent {email}`
    },
    phoneNumber: {
        id: '_.pending_view.phoneNumber',
        defaultMessage: '+44-020-3778-0105'
    },
    email: {
        id: '_.pending_view.email',
        defaultMessage: 'support@iwoca.co.uk'
    }
});
